import _ from 'lodash';
import * as Yup from 'yup';
import Lazy from 'yup/lib/Lazy';
import { CultureTextModel } from '../models/form/form';
import translations from '../i18n/index';

export const languages: { text: string; locale: string }[] = [
  { text: 'english', locale: 'en' },
  { text: 'french', locale: 'fr' },
];

export const getText = (
  text: { culture: string; value: string }[] | string | undefined,
  culture: string | undefined,
): string => {
  if (_.isArray(text)) {
    const cultureText = _.find(text, (t) => _.startsWith(t.culture, culture)) || text[0];

    return _.get(cultureText, 'value');
  }

  return text || '';
};

export const isCultureArray = (element: unknown | CultureTextModel[]): element is CultureTextModel[] => {
  if (_.isArray(element)) {
    return element.every((item) => item.hasOwnProperty('culture') && item.hasOwnProperty('value'));
  }

  return false;
};

export const addLanguage = (
  value: CultureTextModel[] | string,
  selectedCulture: string,
  newCulture: string,
): CultureTextModel[] => {
  if (_.isArray(value)) {
    const selectedCultureModel = _.find(value, (v) => _.startsWith(v.culture, selectedCulture)) || value[0];
    if (selectedCultureModel) {
      return [...value, { value: selectedCultureModel.value, culture: newCulture }];
    }
  } else if (_.isString(value)) {
    return [
      { culture: selectedCulture, value: value },
      { culture: newCulture, value: value },
    ];
  }

  return value;
};

export const removeLanguage = (value: CultureTextModel[], deletedCulture: string): CultureTextModel[] => {
  return value.filter((t) => t.culture != deletedCulture);
};

export const cultureYup = (valueSchema: Yup.StringSchema): Lazy<Yup.AnySchema> => {
  return Yup.lazy((value) => {
    if (_.isArray(value)) {
      return Yup.array().of(
        Yup.object().shape({
          culture: Yup.string().required(),
          value: valueSchema,
        }),
      );
    } else {
      return valueSchema;
    }
  });
};

export const formatMessageByCulture = (message: string, culture: string): string => {
  const localeMessages = translations[culture] || {};
  return localeMessages[message] || message;
};
